import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=37d461dc"
import script from "./OnboardingView.vue?vue&type=script&lang=js"
export * from "./OnboardingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports